import {
  Button,
  Flex,
  FlexColumn,
  SelectInput,
  WarningInfo,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useState } from 'react';
import {
  AvmResultType,
  useChecklistContext,
} from '../../../../../../contexts';
import { ChecklistSection } from '../../../../ChecklistPage';
import { GenericSection } from '../../../GenericSection';

const AvmSearchWrapper = styled(FlexColumn)`${({ theme }) => `
  padding: ${theme.padding[1]} ${theme.padding[9]};;
  gap: ${theme.padding[5]};
`}`;

const AvmSearchContent = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[5]};
  align-items: end;
  width: 50%;
`}`;

const SearchButton = styled(Button)`${({ theme }) => `
  padding: 0px ${theme.padding[8]};
`}`;

export default function AvmSearchSection() {
  const { runAvmSearch } = useChecklistContext();
  const [avmType, setAvmType] = useState<string>('');

  const onChange = (avmType: string) => {
    setAvmType(avmType);
  };

  const onRunAvmSearch = async () => {
    await runAvmSearch(avmType as any);
  };

  return (
    <GenericSection
      subSection={ChecklistSection.VALUATION_AVM_SEARCH}
      level={1}
    >
      <AvmSearchWrapper>
        <WarningInfo>Should only be requested as an exception. Property information will be taken from the Application tab – Security details</WarningInfo>
        <AvmSearchContent>
          <SelectInput
            onChange={onChange}
            value={avmType}
            label="Search Type"
            placeholder="Please select"
            options={AvmResultType}
            required
            id="avm-search-type"
          />
          <SearchButton onClick={onRunAvmSearch} small disabled={!avmType}>Re-Run AVM</SearchButton>
        </AvmSearchContent>
      </AvmSearchWrapper>
    </GenericSection>
  );
}
